<template>
    <div>
        <b-card no-body >
            <div class="row">
                <input-text class="col-12" label="Nomeie sua projeção" v-model="form.nome" ref="form-nome" required/>
                <input-select class="col-12 col-md-6" label="Período da média ROL e SELIC" :options="options.media" v-model="form.periodoEstudoProjecao" ref="form-rol" required/>
                <input-select class="col-12 col-md-6" label="Período da projeção" :options="options.periodo" ref="form-periodo" v-model="form.periodoProjecaoFutura" required/>
                <div class="col-12 d-flex align-items-center">
                    <b-button variant="primary" v-b-modal.modal-projetos class="mr-2">
                        Adicionar projetos
                    </b-button>
                    <b-button variant="success" @click="simular" class="mr-2">
                        Simular
                    </b-button>
                    <div class="border-left pl-2">
                        <b-button variant="outline-secondary" @click="limpar" class="mr-2">
                            Limpar
                        </b-button>
                    </div>
                </div>
            </div>
            <b-modal title="Adicionar projeto" ok-title="Adicionar" ok-variant="success" cancel-title="Fechar" size="xl" id="modal-projetos" @ok="adicionarProjeto" @cancel="limparSubform">
                <div class="row">
                    <div class="col-12 row pr-0" v-for="item,i in subform" :key="`proj-${i}`">
                        <input-date-time class="col-12 col-md-4" label="Data de inicio" v-model="item.dataInicio" ref="subform-datainicio" required>
                            <template #prepend>
                                <b-button v-if="subform.length > 1" class="mr-2" variant="flat-danger" @click="removerProjetoModal(item)">
                                    <i class="fas fa-trash"></i>
                                </b-button>
                            </template>
                        </input-date-time>
                        <input-select class="col-12 col-md-4" label="Periodicidade" :options="options.periodicidade" v-model="item.periodicidade" ref="subform-periodicidade" required/>
                        <input-money class="col-12 col-md-4" label="Valor" v-model="item.valor" ref="subform-valor" required/>
                    </div>
                    <div class="col-12">
                        <b-button variant="info" @click="adicionarNovoProjeto">
                            <div class="d-flex align-items-center">
                                <i class="fas fa-plus mr-2"></i>
                                <span>Adicionar projeto</span>
                            </div>
                        </b-button>
                    </div>
                </div>
            </b-modal>
            <hr v-if="form.projetos.length > 0"/>
            <div class="row" v-if="form.projetos.length > 0">
                <div class="col-12"><h6>Projetos</h6></div>
                <b-table class="mx-2" head-variant="dark" small :items="form.projetos" :fields="colunas">
                    <template #cell(acoes)="data">
                        <div class="d-flex align-items-center">
                            <b-button variant="flat-danger" @click="removerProjeto(data.item)">
                                <i class="fas fa-trash"></i>
                            </b-button>
                        </div>
                    </template>
                </b-table>
            </div>
        </b-card>
        <accordion 
            v-if="dados.id"  
            id="grafico" 
            title="Resultado do estudo"
            class="mt-3" 
            visible            
        >
            <template #append-title>
                <b-button size="sm" class="ml-2" @click="salvar" variant="success">
                    <i class="fas fa-check mr-2"></i>
                    Salvar projeção
                </b-button>
            </template>
            <div>
                <projecao-card :dados="dados" />
            </div> 
        </accordion>


        <hr v-if="salvos.length > 0"/>
        <h6 v-if="salvos.length > 0">Projeções salvas</h6>
        <accordion 
            v-for="projecao in salvos"
            :key="projecao.id"  
            :id="projecao.id" 
            :title="projecao.nome"
            class="mt-3" 
            @abriu="abriu(projecao)"      
        >
            <projecao-card :dados="projecao.dados" v-if="projecao.dados" />
        </accordion>
    </div>
</template>
<script>
import InputSelect from "@/components/inputs/InputSelect";
import InputText from "@/components/inputs/InputText.vue";
import InputDateTime from "../../components/inputs/InputDateTime.vue";
import InputMoney from "../../components/inputs/InputMoney.vue";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";
import { START_LOADING, STOP_LOADING } from "@/store/Store";


import ProjecaoCard from "./ProjecaoCard.vue";

import helpers from "@/common/utils/helpers";

import Accordion from '@/components/card/Accordion';
import { FormMixin } from "@/common/mixins/FormMixin";
import { AlertasMixin } from "@/common/mixins/AlertasMixin";
import ProjecaoFinanceira from "@/common/services/projecao_financeira/projecao_financeira.service";
import cloneDeep from "lodash.clonedeep";
export default {
    name: "ProjecaoFinanceira",
    mixins : [FormMixin, AlertasMixin],
    components: {
        InputSelect,
        InputText,
        InputMoney,
        InputDateTime,
        Accordion,
        ProjecaoCard
    },
    data : () => ({
        form : {
            periodoEstudoProjecao : "",
            periodoProjecaoFutura : "",
            nome : "",
            projetos : [],
        },
        subform : [
            {
                dataInicio : null,
                periodicidade : null,
                valor : null,
            }
        ],
        options : {
            periodo : [
                {value: "Doze", text: "12 meses"},
                {value: "VinteQuatro", text: "24 meses"},
                {value: "TrinteESeis", text: "36 meses"},
                {value: "QuarentaEOito", text: "48 meses"},
            ],
            media : [
                {value: "Doze", text: "12 meses"},
                {value: "VinteQuatro", text: "24 meses"},
                {value: "TrinteESeis", text: "36 meses"},
            ],
            periodicidade : helpers.Periodicidade
        },
        colunas : [
            {key : "dataInicio", label : "Data de inicio", formatter : (v) => { if(v) return helpers.formatarDataBr(v)}},
            {key : "periodicidade", label : "Periodicidade"},
            {key : "valor", label : "Valor", formatter : (v) => { if(v) return helpers.formatarValor(v)}},
            {key : "acoes", label : "Ações"},
        ],
        
        dados : {},
        salvos : []
    }),
    mounted() {
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            {titulo : "Projeção financeira"},
        ]);
        this.buscar()
    },
    methods : {
        removerProjetoModal : function(item){
            this.subform.splice(this.subform.indexOf(item),1);
        },
        adicionarNovoProjeto : function(){
            this.subform.push({
                dataInicio : null,
                periodicidade : null,
                valor : null,
            });
        },
        limpar : function(){
            this.form = {
                periodoEstudoProjecao : "",
                periodoProjecaoFutura : "",
                nome : "",
                projetos : [],
            };
        },
        removerProjeto : function(item){
            this.form.projetos.splice(this.form.projetos.indexOf(item),1);
        },
        limparSubform : function(){
            this.subform = [{
                dataInicio : null,
                periodicidade : null,
                valor : null,
            }]
        },
        adicionarProjeto : function(e){
            e.preventDefault();
            
            if(!this.validarFormulario("subform-"))
                return false;

            let form = cloneDeep(this.subform);
            form = form.map(el => {
                el.valor  = helpers.removerValor(el.valor);
                return el;
            })
            this.form.projetos.push(...form);

            this.limparSubform();

            this.$nextTick(() => {
                this.$bvModal.hide('modal-projetos')
            })
        },
        abriu(projecao){
            this.$store.dispatch(START_LOADING);
            ProjecaoFinanceira.salvos(projecao.id).then(res => {
                let dados = res.data.data;
                dados.pontos = this.ordenarPontos(dados.pontos);
                dados.pontosMedia2Anos = this.ordenarPontos(dados.pontosMedia2Anos);
                projecao.dados = dados;
            }).catch(err => {
                console.error(err)
                this.alertaErro("Ocorreu um erro ao buscar!")
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            })
        },
        simular(){
            if(!this.validarFormulario("form-"))
                return false;

            this.$store.dispatch(START_LOADING);
            let form = cloneDeep(this.form);
            form.empresaId = this.empresaSelecionada;
            ProjecaoFinanceira.simular(form).then(res => {
                this.dados = res.data.data;
            }).catch(() => {
                this.alertaErro("Ocorreu um erro ao simular!")
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });            
        },
        salvar(e){
            e.stopPropagation();
            
            this.confirmar("Deseja salvar essa projeção financeira?").then(confirmado => {
                if(!confirmado)
                    return;
                this.$store.dispatch(START_LOADING);
                let form = {
                    "periodoEstudoProjecao": this.form.periodoEstudoProjecao,
                    "periodoProjecaoFutura": this.form.periodoProjecaoFutura,
                    "projetos" : this.form.projetos,
                    "empresaId": this.empresaSelecionada,
                    "nome": this.form.nome
                }
                ProjecaoFinanceira.salvar(form).then(() => {
                    this.alertaSucesso("Projeção salva com sucesso!")
                    this.dados = {};
                    this.buscar();
                }).catch(() => {
                    this.alertaErro("Ocorreu um erro ao simular!")
                }).finally(() => {
                    this.$store.dispatch(STOP_LOADING);
                })
            })
            
        },
        buscar(){
            this.$store.dispatch(START_LOADING);
            ProjecaoFinanceira.selecao(this.empresaSelecionada).then(res => {
                this.salvos = res.data.data.map(el => {
                    el.dados = null;
                    return el;
                });
            }).catch(() => {
                this.alertaErro("Ocorreu um erro ao buscar!")
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            })
        },
        ordenarPontos(pontos){
            return pontos.sort((a,b) => {
                let aIndice = helpers.retornarIndiceMes(a.mes);
                let bIndice = helpers.retornarIndiceMes(b.mes);
                if(a.ano > b.ano)
                    return 1;
                if(a.ano < b.ano)
                    return -1;

                if(aIndice == bIndice && a.ano > b.ano)
                    return 1;
                if(aIndice == bIndice && a.ano < b.ano)
                    return -1;
                if(aIndice > bIndice && a.ano == b.ano)
                    return 1;
                if(aIndice < bIndice && a.ano == b.ano)
                    return -1;
                return 0;
            });
        }
    },
    computed : {
        empresaSelecionada: function(){
            return this.$store.state.app.selectedCompanyObj ? this.$store.state.app.selectedCompanyObj.id : null;
        },
    },
    
}
</script>
<style lang="">
    
</style>